export const getCities = () => {
    const CITIES = [
        "Bristol, VA",
        "Abingdon, VA",
        "Big Stone Gap, VA",
        "Blackwater, VA",
        "Castlewood, VA",
        "Damascus, VA",
        "Dryden, VA",
        "Duffield, VA",
        "Ewing, VA",
        "Gate City, VA",
        "Hiltons, VA",
        "Jonesville, VA",
        "Keokee, VA",
        "Mendota, VA",
        "Nickelsville, VA",
        "Pennington Gap, VA",
        "Rose Hill, VA",
        "Saint Charles, VA",
        "Whitetop, VA",
        "Banner Elk, NC",
        "Blowing Rock, NC",
        "Collettsville, NC",
        "Creston, NC",
        "Crossnore, NC",
        "Elk Park, NC",
        "Jonas Ridge, NC",
        "Lansing, NC",
        "Linville, NC",
        "Linville Falls, NC",
        "Minneapolis, NC",
        "Montezuma, NC",
        "Newland, NC",
        "Pineola, NC",
        "Sugar Grove, NC",
        "Vilas, NC",
        "Zionville, NC",
        "Bakersville, NC",
        "Cherokee, NC",
        "Clyde, NC",
        "Hot Springs, NC",
        "Marion, NC",
        "Marshall, NC",
        "Robbinsville, NC",
        "Brasstown, NC",
        "Culberson, NC",
        "Hayesville, NC",
        "Marble, NC",
        "Murphy, NC",
        "Warne, NC",
        "Adairsville, GA",
        "Armuchee, GA",
        "Cave Spring, GA",
        "Cedartown, GA",
        "Fairmount, GA",
        "Rome, GA",
        "Rydal, GA",
        "Blairsville, GA",
        "Blue Ridge, GA",
        "Cherrylog, GA",
        "Clarkesville, GA",
        "Clayton, GA",
        "Cleveland, GA",
        "Dahlonega, GA",
        "Ellijay, GA",
        "Epworth, GA",
        "Helen, GA",
        "Hiawassee, GA",
        "MC Caysville, GA",
        "Mineral Bluff, GA",
        "Morganton, GA",
        "Sautee Nacoochee, GA",
        "Suches, GA",
        "Young Harris, GA",
        "Calhoun, GA",
        "Chatsworth, GA",
        "Chickamauga, GA",
        "Cisco, GA",
        "Cohutta, GA",
        "Crandall, GA",
        "Dalton, GA",
        "Flintstone, GA",
        "Graysville, GA",
        "La Fayette, GA",
        "Lyerly, GA",
        "Menlo, GA",
        "Plainville, GA",
        "Ranger, GA",
        "Resaca, GA",
        "Ringgold, GA",
        "Rising Fawn, GA",
        "Rock Spring, GA",
        "Rocky Face, GA",
        "Rossville, GA",
        "Fort Oglethorpe, GA",
        "Sugar Valley, GA",
        "Summerville, GA",
        "Lookout Mountain, GA",
        "Tennga, GA",
        "Trenton, GA",
        "Trion, GA",
        "Tunnel Hill, GA",
        "Varnell, GA",
        "Wildwood, GA",
        "Arab, AL",
        "Baileyton, AL",
        "Bessemer, AL",
        "Blountsville, AL",
        "Bremen, AL",
        "Crane Hill, AL",
        "Cullman, AL",
        "Empire, AL",
        "Garden City, AL",
        "Hanceville, AL",
        "Hayden, AL",
        "Holly Pond, AL",
        "Joppa, AL",
        "Logan, AL",
        "MC Calla, AL",
        "Union Grove, AL",
        "Vinemont, AL",
        "Birmingham, AL",
        "Jasper, AL",
        "Addison, AL",
        "Arley, AL",
        "Double Springs, AL",
        "Hodges, AL",
        "Houston, AL",
        "Phil Campbell, AL",
        "Red Bay, AL",
        "Spruce Pine, AL",
        "Vina, AL",
        "Decatur, AL",
        "Anderson, AL",
        "Athens, AL",
        "Belle Mina, AL",
        "Cherokee, AL",
        "Cloverdale, AL",
        "Courtland, AL",
        "Danville, AL",
        "Elkmont, AL",
        "Eva, AL",
        "Falkville, AL",
        "Florence, AL",
        "Hartselle, AL",
        "Hillsboro, AL",
        "Killen, AL",
        "Leighton, AL",
        "Lester, AL",
        "Lexington, AL",
        "Mooresville, AL",
        "Moulton, AL",
        "Mount Hope, AL",
        "Rogersville, AL",
        "Russellville, AL",
        "Sheffield, AL",
        "Muscle Shoals, AL",
        "Somerville, AL",
        "Tanner, AL",
        "Town Creek, AL",
        "Trinity, AL",
        "Tuscumbia, AL",
        "Waterloo, AL",
        "Ardmore, AL",
        "Bridgeport, AL",
        "Brownsboro, AL",
        "Capshaw, AL",
        "Dutton, AL",
        "Estillfork, AL",
        "Fackler, AL",
        "Grant, AL",
        "Gurley, AL",
        "Harvest, AL",
        "Hazel Green, AL",
        "Hollytree, AL",
        "Hollywood, AL",
        "Laceys Spring, AL",
        "Langston, AL",
        "Madison, AL",
        "Meridianville, AL",
        "New Hope, AL",
        "New Market, AL",
        "Normal, AL",
        "Owens Cross Roads, AL",
        "Paint Rock, AL",
        "Pisgah, AL",
        "Princeton, AL",
        "Ryland, AL",
        "Scottsboro, AL",
        "Section, AL",
        "Stevenson, AL",
        "Toney, AL",
        "Trenton, AL",
        "Valhermoso Springs, AL",
        "Woodville, AL",
        "Huntsville, AL",
        "Gadsden, AL",
        "Albertville, AL",
        "Altoona, AL",
        "Attalla, AL",
        "Boaz, AL",
        "Bryant, AL",
        "Cedar Bluff, AL",
        "Centre, AL",
        "Collinsville, AL",
        "Crossville, AL",
        "Dawson, AL",
        "Douglas, AL",
        "Flat Rock, AL",
        "Fort Payne, AL",
        "Fyffe, AL",
        "Gaylesville, AL",
        "Geraldine, AL",
        "Groveoak, AL",
        "Guntersville, AL",
        "Henagar, AL",
        "Higdon, AL",
        "Horton, AL",
        "Ider, AL",
        "Leesburg, AL",
        "Mentone, AL",
        "Rainsville, AL",
        "Sylvania, AL",
        "Valley Head, AL",
        "Jacksonville, AL",
        "Piedmont, AL",
        "Spring Garden, AL",
        "Wellington, AL",
        "Adams, TN",
        "Antioch, TN",
        "Alexandria, TN",
        "Arrington, TN",
        "Ashland City, TN",
        "Auburntown, TN",
        "Beechgrove, TN",
        "Belfast, TN",
        "Bell Buckle, TN",
        "Bethpage, TN",
        "Big Rock, TN",
        "Brentwood, TN",
        "Bon Aqua, TN",
        "Bradyville, TN",
        "Bumpus Mills, TN",
        "Burns, TN",
        "Carthage, TN",
        "Castalian Springs, TN",
        "Cedar Hill, TN",
        "Centerville, TN",
        "Chapel Hill, TN",
        "Chapmansboro, TN",
        "Charlotte, TN",
        "Christiana, TN",
        "Clarksville, TN",
        "College Grove, TN",
        "Cornersville, TN",
        "Cottontown, TN",
        "Cross Plains, TN",
        "Cumberland City, TN",
        "Cumberland Furnace, TN",
        "Cunningham, TN",
        "Dickson, TN",
        "Dixon Springs, TN",
        "Dover, TN",
        "Dowelltown, TN",
        "Eagleville, TN",
        "Erin, TN",
        "Fairview, TN",
        "Fosterville, TN",
        "Franklin, TN",
        "Gallatin, TN",
        "Goodlettsville, TN",
        "Gladeville, TN",
        "Richmond Ave NW, TN",
        "Hartsville, TN",
        "Hendersonville, TN",
        "Hermitage, TN",
        "Hurricane Mills, TN",
        "Indian Mound, TN",
        "County Road 246, TN",
        "Kingston Springs, TN",
        "Lafayette, TN",
        "Lascassas, TN",
        "La Vergne, TN",
        "Lebanon, TN",
        "Lewisburg, TN",
        "Liberty, TN",
        "Linden, TN",
        "Lobelville, TN",
        "Lyles, TN",
        "Mc Ewen, TN",
        "MC Minnville, TN",
        "Madison, TN",
        "Milton, TN",
        "Mitchellville, TN",
        "Mount Juliet, TN",
        "Murfreesboro, TN",
        "New Johnsonville, TN",
        "Nolensville, TN",
        "Norene, TN",
        "Nunnelly, TN",
        "Old Hickory, TN",
        "Only, TN",
        "Orlinda, TN",
        "Palmyra, TN",
        "Pegram, TN",
        "Petersburg, TN",
        "Pleasant Shade, TN",
        "Pleasant View, TN",
        "Portland, TN",
        "Readyville, TN",
        "Red Boiling Springs, TN",
        "Riddleton, TN",
        "Ridgetop, TN",
        "Rockvale, TN",
        "Shelbyville, TN",
        "Slayden, TN",
        "Smithville, TN",
        "Smyrna, TN",
        "Southside, TN",
        "Springfield, TN",
        "Spring Hill, TN",
        "Stewart, TN",
        "Tennessee Ridge, TN",
        "Thompsons Station, TN",
        "Unionville, TN",
        "Vanleer, TN",
        "Wartrace, TN",
        "Watertown, TN",
        "Waverly, TN",
        "Westmoreland, TN",
        "White Bluff, TN",
        "White House, TN",
        "Whites Creek, TN",
        "Woodbury, TN",
        "Woodlawn, TN",
        "Nashville, TN",
        "Altamont, TN",
        "Apison, TN",
        "Athens, TN",
        "Bakewell, TN",
        "Beersheba Springs, TN",
        "Belvidere, TN",
        "Benton, TN",
        "Birchwood, TN",
        "Calhoun, TN",
        "Charleston, TN",
        "Cleveland, TN",
        "Coalmont, TN",
        "Cokercreek, TN",
        "Collegedale, TN",
        "Conasauga, TN",
        "Copperhill, TN",
        "Cowan, TN",
        "Dayton, TN",
        "Decatur, TN",
        "Decherd, TN",
        "Delano, TN",
        "Ducktown, TN",
        "Dunlap, TN",
        "Elora, TN",
        "Englewood, TN",
        "Estill Springs, TN",
        "Etowah, TN",
        "Evensville, TN",
        "Farner, TN",
        "Fayetteville, TN",
        "Flintville, TN",
        "Georgetown, TN",
        "Grandview, TN",
        "Graysville, TN",
        "Gruetli Laager, TN",
        "Guild, TN",
        "Harrison, TN",
        "Hillsboro, TN",
        "Hixson, TN",
        "Huntland, TN",
        "Jasper, TN",
        "Kelso, TN",
        "Manchester, TN",
        "Lookout Mountain, TN",
        "Lupton City, TN",
        "Lynchburg, TN",
        "Mc Donald, TN",
        "Madisonville, TN",
        "Monteagle, TN",
        "Morrison, TN",
        "Mulberry, TN",
        "Normandy, TN",
        "Ocoee, TN",
        "Old Fort, TN",
        "Ooltewah, TN",
        "Palmer, TN",
        "Pelham, TN",
        "Pikeville, TN",
        "Reliance, TN",
        "Riceville, TN",
        "Sale Creek, TN",
        "Sequatchie, TN",
        "Sewanee, TN",
        "Sherwood, TN",
        "Signal Mountain, TN",
        "Smartt, TN",
        "Soddy Daisy, TN",
        "South Pittsburg, TN",
        "Spring City, TN",
        "Summitville, TN",
        "Tellico Plains, TN",
        "Tracy City, TN",
        "Tullahoma, TN",
        "Arnold A F B, TN",
        "Turtletown, TN",
        "Viola, TN",
        "Whiteside, TN",
        "Whitwell, TN",
        "Winchester, TN",
        "Chattanooga, TN",
        "Memphis, TN",
        "Johnson City, TN",
        "Afton, TN",
        "Blountville, TN",
        "Bluff City, TN",
        "Bristol, TN",
        "Butler, TN",
        "Chuckey, TN",
        "Church Hill, TN",
        "Elizabethton, TN",
        "Mount Carmel, TN",
        "Erwin, TN",
        "Fall Branch, TN",
        "Flag Pond, TN",
        "Hampshire, TN",
        "Jonesborough, TN",
        "Kingsport, TN",
        "Laurel Bloomery, TN",
        "Limestone, TN",
        "Milligan College, TN",
        "Mountain City, TN",
        "Mountain Home, TN",
        "Piney Flats, TN",
        "Roan Mountain, TN",
        "Shady Valley, TN",
        "Telford, TN",
        "Trade, TN",
        "Unicoi, TN",
        "Wautaga, TN",
        "Alcoa, TN",
        "Andersonville, TN",
        "Arthur, TN",
        "Bean Station, TN",
        "Blaine, TN",
        "Briceville, TN",
        "Bulls Gap, TN",
        "Bybee, TN",
        "Caryville, TN",
        "Clairfield, TN",
        "Clinton, TN",
        "Coalfield, TN",
        "Corryton, TN",
        "Cosby, TN",
        "Crab Orchard, TN",
        "Cumberland Gap, TN",
        "Dandridge, TN",
        "Deer Lodge, TN",
        "Del Rio, TN",
        "Duff, TN",
        "Eagan, TN",
        "Eidson, TN",
        "Elgin, TN",
        "Rugby, TN",
        "Friendsville, TN",
        "Gatlinburg, TN",
        "Greenback, TN",
        "Greeneville, TN",
        "Harriman, TN",
        "Harrogate, TN",
        "Hartford, TN",
        "Heiskell, TN",
        "Helenwood, TN",
        "Huntsville, TN",
        "Jacksboro, TN",
        "Jefferson City, TN",
        "Jellico, TN",
        "Kingston, TN",
        "Kodak, TN",
        "Kyles Ford, TN",
        "La Follette, TN",
        "Lake City, TN",
        "Lancing, TN",
        "Lenoir City, TN",
        "Lone Mountain, TN",
        "Loudon, TN",
        "Louisville, TN",
        "Lowland, TN",
        "Luttrell, TN",
        "Maryville, TN",
        "Mascot, TN",
        "Maynardville, TN",
        "Midway, TN",
        "Mohawk, TN",
        "Mooresburg, TN",
        "Morristown, TN",
        "Mosheim, TN",
        "Newcomb, TN",
        "New Market, TN",
        "Newport, TN",
        "New Tazewell, TN",
        "Niota, TN",
        "Norris, TN",
        "Oakdale, TN",
        "Oak Ridge, TN",
        "Oliver Springs, TN",
        "Oneida, TN",
        "Parrottsville, TN",
        "Petros, TN",
        "Philadelphia, TN",
        "Pioneer, TN",
        "Powder Springs, TN",
        "Powell, TN",
        "Pruden, TN",
        "Robbins, TN",
        "Rockford, TN",
        "Rockwood, TN",
        "Rogersville, TN",
        "Russellville, TN",
        "Rutledge, TN",
        "Sevierville, TN",
        "Pigeon Forge, TN",
        "Seymour, TN",
        "Sharps Chapel, TN",
        "Shawanee, TN",
        "Sneedville, TN",
        "Speedwell, TN",
        "Strawberry Plains, TN",
        "Sunbright, TN",
        "Surgoinsville, TN",
        "Sweetwater, TN",
        "Talbott, TN",
        "Tallassee, TN",
        "Tazewell, TN",
        "Ten Mile, TN",
        "Thorn Hill, TN",
        "Townsend, TN",
        "Vonore, TN",
        "Walland, TN",
        "Wartburg, TN",
        "Washburn, TN",
        "White Pine, TN",
        "Whitesburg, TN",
        "Winfield, TN",
        "Knoxville, TN",
        "Alamo, TN",
        "Arlington, TN",
        "Atoka, TN",
        "Bells, TN",
        "Bogota, TN",
        "Bolivar, TN",
        "Braden, TN",
        "Brighton, TN",
        "Brownsville, TN",
        "Brunswick, TN",
        "Burlison, TN",
        "Cordova, TN",
        "Collierville, TN",
        "Covington, TN",
        "Crockett Mills, TN",
        "Drummonds, TN",
        "Dyersburg, TN",
        "Eads, TN",
        "Ellendale, TN",
        "Finley, TN",
        "Friendship, TN",
        "Gallaway, TN",
        "Jenso Dr NW, TN",
        "Grand Junction, TN",
        "Halls, TN",
        "Henning, TN",
        "Hickory Valley, TN",
        "Hornsby, TN",
        "Laconia, TN",
        "La Grange, TN",
        "Lenox, TN",
        "Macon, TN",
        "Mason, TN",
        "Maury City, TN",
        "Middleton, TN",
        "Millington, TN",
        "Moscow, TN",
        "Munford, TN",
        "Newbern, TN",
        "Oakland, TN",
        "Pocahontas, TN",
        "Ripley, TN",
        "Rossville, TN",
        "Saulsbury, TN",
        "Somerville, TN",
        "Stanton, TN",
        "Tigrett, TN",
        "Tipton, TN",
        "Whiteville, TN",
        "Williston, TN",
        "Wynnburg, TN",
        "Tiptonville, TN",
        "Ridgely, TN",
        "Germantown, TN",
        "Mc Kenzie, TN",
        "Atwood, TN",
        "Big Sandy, TN",
        "Buchanan, TN",
        "Como, TN",
        "Cottage Grove, TN",
        "Dresden, TN",
        "Dukedom, TN",
        "Gleason, TN",
        "Greenfield, TN",
        "Henry, TN",
        "Hornbeak, TN",
        "Kenton, TN",
        "MC Lemoresville, TN",
        "Mansfield, TN",
        "Martin, TN",
        "Obion, TN",
        "Palmersville, TN",
        "Paris, TN",
        "Puryear, TN",
        "Rives, TN",
        "Samburg, TN",
        "Sharon, TN",
        "Springville, TN",
        "South Fulton, TN",
        "Trezevant, TN",
        "Trimble, TN",
        "Troy, TN",
        "Union City, TN",
        "Woodland Mills, TN",
        "Jackson, TN",
        "Adamsville, TN",
        "Bath Springs, TN",
        "Lynnmont Rd NW, TN",
        "Bethel Springs, TN",
        "Bradford, TN",
        "Bruceton, TN",
        "Buena Vista, TN",
        "Camden, TN",
        "Cedar Grove, TN",
        "Clarksburg, TN",
        "Counce, TN",
        "Crump, TN",
        "Darden, TN",
        "Decaturville, TN",
        "Dyer, TN",
        "Eaton, TN",
        "Enville, TN",
        "Eva, TN",
        "Finger, TN",
        "Fruitvale, TN",
        "Gadsden, TN",
        "Gibson, TN",
        "Guys, TN",
        "Henderson, TN",
        "Holladay, TN",
        "Hollow Rock, TN",
        "Humboldt, TN",
        "Huntingdon, TN",
        "Huron, TN",
        "Idlewild, TN",
        "Jacks Creek, TN",
        "Lavinia, TN",
        "Lexington, TN",
        "Luray, TN",
        "Medina, TN",
        "Medon, TN",
        "Michie, TN",
        "Milan, TN",
        "Milledgeville, TN",
        "Morris Chapel, TN",
        "Oakfield, TN",
        "Parsons, TN",
        "Pickwick Dam, TN",
        "Pinson, TN",
        "Ramer, TN",
        "Reagan, TN",
        "Rutherford, TN",
        "Saltillo, TN",
        "Sardis, TN",
        "Savannah, TN",
        "Scotts Hill, TN",
        "Selmer, TN",
        "Shiloh, TN",
        "Spring Creek, TN",
        "Stantonville, TN",
        "Sugar Tree, TN",
        "Toone, TN",
        "Trenton, TN",
        "Westport, TN",
        "Wildersville, TN",
        "Yorkville, TN",
        "Yuma, TN",
        "Denmark, TN",
        "Mercer, TN",
        "Chewalla, TN",
        "Columbia, TN",
        "Clifton, TN",
        "Ardmore, TN",
        "Collinwood, TN",
        "Culleoka, TN",
        "Cypress Inn, TN",
        "Dellrose, TN",
        "Duck River, TN",
        "Elkton, TN",
        "Ethridge, TN",
        "Five Points, TN",
        "Frankewing, TN",
        "Goodspring, TN",
        "Hohenwald, TN",
        "Iron City, TN",
        "Lawrenceburg, TN",
        "Leoma, TN",
        "Loretto, TN",
        "Lutts, TN",
        "Lynnville, TN",
        "Minor Hill, TN",
        "Mount Pleasant, TN",
        "Olivehill, TN",
        "Primm Springs, TN",
        "Prospect, TN",
        "Pulaski, TN",
        "Saint Joseph, TN",
        "Santa Fe, TN",
        "Summertown, TN",
        "Waynesboro, TN",
        "Westpoint, TN",
        "Williamsport, TN",
        "Taft, TN",
        "Cookeville, TN",
        "Allardt, TN",
        "Allons, TN",
        "Allred, TN",
        "Alpine, TN",
        "Baxter, TN",
        "Bloomington Springs, TN",
        "Brush Creek, TN",
        "Buffalo Valley, TN",
        "Byrdstown, TN",
        "Campaign, TN",
        "Celina, TN",
        "Chestnut Mound, TN",
        "Clarkrange, TN",
        "Crawford, TN",
        "Crossville, TN",
        "Jamestown, TN",
        "Doyle, TN",
        "Elmwood, TN",
        "Gainesboro, TN",
        "Gordonsville, TN",
        "Granville, TN",
        "Grimsley, TN",
        "Hickman, TN",
        "Hilham, TN",
        "Lancaster, TN",
        "Livingston, TN",
        "Monroe, TN",
        "Monterey, TN",
        "Moss, TN",
        "Pall Mall, TN",
        "Pleasant Hill, TN",
        "Quebeck, TN",
        "Rickman, TN",
        "Rock Island, TN",
        "Silver Point, TN",
        "Sparta, TN",
        "Spencer, TN",
        "Walling, TN",
        "Whitleyville, TN",
        "Wilder, TN",
        "Abbeville, MS",
        "Arkabutla, MS",
        "Ashland, MS",
        "Batesville, MS",
        "Blue Mountain, MS",
        "Byhalia, MS",
        "Coldwater, MS",
        "Como, MS",
        "Courtland, MS",
        "Crenshaw, MS",
        "Crowder, MS",
        "Dumas, MS",
        "Dundee, MS",
        "Etta, MS",
        "Falkner, MS",
        "Hernando, MS",
        "Hickory Flat, MS",
        "Holly Springs, MS",
        "Independence, MS",
        "Lake Cormorant, MS",
        "Lamar, MS",
        "Lambert, MS",
        "Marks, MS",
        "Michigan City, MS",
        "Myrtle, MS",
        "New Albany, MS",
        "Olive Branch, MS",
        "Oxford, MS",
        "Pope, MS",
        "Potts Camp, MS",
        "Red Banks, MS",
        "Ripley, MS",
        "Sarah, MS",
        "Sardis, MS",
        "Senatobia, MS",
        "Sledge, MS",
        "Southaven, MS",
        "Taylor, MS",
        "Tiplersville, MS",
        "Tula, MS",
        "Tunica, MS",
        "University, MS",
        "Victoria, MS",
        "Walls, MS",
        "Walnut, MS",
        "Waterford, MS",
        "Tupelo, MS",
        "Algoma, MS",
        "Amory, MS",
        "Baldwyn, MS",
        "Becker, MS",
        "Belden, MS",
        "Belmont, MS",
        "Blue Springs, MS",
        "Booneville, MS",
        "Burnsville, MS",
        "Corinth, MS",
        "Dennis, MS",
        "Derma, MS",
        "Ecru, MS",
        "Fulton, MS",
        "Gattman, MS",
        "Glen, MS",
        "Golden, MS",
        "Greenwood Springs, MS",
        "Guntown, MS",
        "Houlka, MS",
        "Houston, MS",
        "Iuka, MS",
        "Mantachie, MS",
        "Marietta, MS",
        "Mooreville, MS",
        "Nettleton, MS",
        "New Site, MS",
        "Okolona, MS",
        "Plantersville, MS",
        "Pontotoc, MS",
        "Randolph, MS",
        "Rienzi, MS",
        "Saltillo, MS",
        "Shannon, MS",
        "Sherman, MS",
        "Smithville, MS",
        "Thaxton, MS",
        "Tishomingo, MS",
        "Toccopola, MS",
        "Tremont, MS",
        "Van Vleet, MS",
        "Vardaman, MS",
        "Verona, MS",
        "Wheeler, MS",
        "Grenada, MS",
        "Banner, MS",
        "Big Creek, MS",
        "Bruce, MS",
        "Calhoun City, MS",
        "Cascilla, MS",
        "Charleston, MS",
        "Coffeeville, MS",
        "Enid, MS",
        "Gore Springs, MS",
        "Holcomb, MS",
        "Oakland, MS",
        "Paris, MS",
        "Philipp, MS",
        "Pittsboro, MS",
        "Scobey, MS",
        "Slate Spring, MS",
        "Tillatoba, MS",
        "Tippo, MS",
        "Tutwiler, MS",
        "Vance, MS",
        "Water Valley, MS",
        "Brandon, MS",
        "Camden, MS",
        "Canton, MS",
        "Carthage, MS",
        "Conehatta, MS",
        "Durant, MS",
        "Ethel, MS",
        "Forest, MS",
        "Kosciusko, MS",
        "Lake, MS",
        "Lena, MS",
        "MC Cool, MS",
        "Madden, MS",
        "Madison, MS",
        "Morton, MS",
        "Pelahatchie, MS",
        "Sallis, MS",
        "Sandhill, MS",
        "Thomastown, MS",
        "Walnut Grove, MS",
        "West, MS",
        "Flowood, MS",
        "Meridian, MS",
        "Bailey, MS",
        "Collinsville, MS",
        "Daleville, MS",
        "Decatur, MS",
        "De Kalb, MS",
        "Lauderdale, MS",
        "Lawrence, MS",
        "Little Rock, MS",
        "Louisville, MS",
        "Macon, MS",
        "Newton, MS",
        "Noxapater, MS",
        "Philadelphia, MS",
        "Porterville, MS",
        "Preston, MS",
        "Scooba, MS",
        "Sebastopol, MS",
        "Shuqualak, MS",
        "Union, MS",
        "Columbus, MS",
        "Aberdeen, MS",
        "Ackerman, MS",
        "Artesia, MS",
        "Bellefontaine, MS",
        "Brooksville, MS",
        "Caledonia, MS",
        "Cedarbluff, MS",
        "Crawford, MS",
        "Eupora, MS",
        "French Camp, MS",
        "Hamilton, MS",
        "Kilmichael, MS",
        "Maben, MS",
        "Mantee, MS",
        "Mathiston, MS",
        "Mayhew, MS",
        "Montpelier, MS",
        "Pheba, MS",
        "Prairie, MS",
        "Starkville, MS",
        "Mississippi State, MS",
        "Steens, MS",
        "Sturgis, MS",
        "Walthall, MS",
        "Weir, MS",
        "West Point, MS",
        "Woodland, MS",
        "Falls of Rough, KY",
        "Emlyn, KY",
        "Siler, KY",
        "Williamsburg, KY",
        "Cranks, KY",
        "Harlan, KY",
        "Holmes Mill, KY",
        "Frakes, KY",
        "Middlesboro, KY",
        "Almo, KY",
        "Arlington, KY",
        "Bardwell, KY",
        "Benton, KY",
        "Boaz, KY",
        "Calvert City, KY",
        "Clinton, KY",
        "Columbus, KY",
        "Cunningham, KY",
        "Dexter, KY",
        "Eddyville, KY",
        "Fancy Farm, KY",
        "Farmington, KY",
        "Fulton, KY",
        "Gilbertsville, KY",
        "Grand Rivers, KY",
        "Hardin, KY",
        "Hazel, KY",
        "Hickman, KY",
        "Hickory, KY",
        "Kirksey, KY",
        "Kuttawa, KY",
        "Lynnville, KY",
        "Mayfield, KY",
        "Milburn, KY",
        "Murray, KY",
        "New Concord, KY",
        "Sedalia, KY",
        "Symsonia, KY",
        "Water Valley, KY",
        "Wickliffe, KY",
        "Wingo, KY",
        "Bowling Green, KY",
        "Adolphus, KY",
        "Alvaton, KY",
        "Austin, KY",
        "Beaumont, KY",
        "Cave City, KY",
        "Drake, KY",
        "Edmonton, KY",
        "Fountain Run, KY",
        "Franklin, KY",
        "Gamaliel, KY",
        "Glasgow, KY",
        "Hestand, KY",
        "Holland, KY",
        "Lucas, KY",
        "Mount Hermon, KY",
        "Oakland, KY",
        "Park City, KY",
        "Rocky Hill, KY",
        "Scottsville, KY",
        "Summer Shade, KY",
        "Tompkinsville, KY",
        "Woodburn, KY",
        "Smiths Grove, KY",
        "Aberdeen, KY",
        "Adairville, KY",
        "Allensville, KY",
        "Auburn, KY",
        "Bee Spring, KY",
        "Brownsville, KY",
        "Cadiz, KY",
        "Cerulean, KY",
        "Clifty, KY",
        "Crofton, KY",
        "Dunbar, KY",
        "Elkton, KY",
        "Fairview, KY",
        "Fort Campbell, TN",
        "Gracey, KY",
        "Guthrie, KY",
        "Herndon, KY",
        "Hopkinsville, KY",
        "Jetson, KY",
        "La Fayette, KY",
        "Lewisburg, KY",
        "Mammoth Cave, KY",
        "Morgantown, KY",
        "Oak Grove, KY",
        "Olmstead, KY",
        "Pembroke, KY",
        "Rochester, KY",
        "Rockfield, KY",
        "Roundhill, KY",
        "Russellville, KY",
        "Sharon Grove, KY",
        "South Union, KY",
        "Sweeden, KY",
        "Trenton, KY",
        "Welchs Creek, KY",
        "Woodbury, KY",
        "Beaver Dam, KY",
        "Beech Creek, KY",
        "Beechmont, KY",
        "Belton, KY",
        "Browder, KY",
        "Central City, KY",
        "Cromwell, KY",
        "Drakesboro, KY",
        "Dundee, KY",
        "Dunmor, KY",
        "Fordsville, KY",
        "Greenville, KY",
        "Hartford, KY",
        "Horse Branch, KY",
        "Olaton, KY",
        "Rockport, KY",
        "Rosine, KY",
        "Dawson Springs, KY",
        "Princeton, KY",
        "White Plains, KY",
        "Albany, KY",
        "Jamestown, KY",
        "Monticello, KY",
        "Strunk, KY",
        "Big Clifty, KY",
        "Breeding, KY",
        "Burkesville, KY",
        "Caneyville, KY",
        "Clarkson, KY",
        "Columbia, KY",
        "Cub Run, KY",
        "Dubre, KY",
        "Glens Fork, KY",
        "Leitchfield, KY",
        "Marrowbone, KY",
        "Millwood, KY",
        "Munfordville, KY",
        "White Mills, KY"
    ]

    return  CITIES.filter((c, i, CITIES) => CITIES.indexOf(c) === i) 
}



